/**
 * Convert a string to “title case” (first letter of each word uppercase, rest lowercase).
 * E.g. "SICK LEAVE HALF DAY"   → "Sick Leave Half Day"
 *       "ANNUAL LEAVE - HALF DAY" → "Annual Leave - Half Day"
 */
export function toTitleCase(str) {
  if (typeof str !== 'string') return str;

  return str
    .trim()
    .split(' ')
    .map(word => {
      if (!word) return '';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}

/**
 * Check if a string is a valid JSON array or a single string.
 * @param {*} str
 * @returns
 */
export const checkStringOrJsonArray = str => {
  try {
    const parsed = JSON.parse(str);
    return Array.isArray(parsed) ? parsed : [parsed];
  } catch {
    return [str];
  }
};
